export default __webpack_public_path__ + "static/media/ps5.a39e54e5.PNG";